export function customChartData() {
  return {
    colors: ['#66CBE0', '#A3E0EC', '#D1EFF6', '#ED9B23', '#F4C37B', '#FBEBD3'],
    chart: {
      title: false,
      spacingTop: 25,
      height: 260,
      backgroundColor: 'transparent'
    },
    legend: {
      enabled: true,
      itemStyle: {
        color: 'white',
        fontWeight: 'normal',
        textOutline: false
      }
    },
    tooltip: {
      valueDecimals: 2
    },
    plotOptions: {
      series: {
        stacking: 'normal',
        marker: {
          enabled: false
        }
      }
    },
    yAxis: {
      tickAmount: 5,
      tickPixelInterval: 80,
      labels: {
        style: {
          color: 'white'
        }
      },
      gridLineColor: '#9A9FAE'
    },
    xAxis: {
      labels: {
        style: {
          color: 'white'
        }
      }
    }
  }
}
